import fetchWrapper from "../../utils/fetchWrapper";

const versionService = () => {

  const getVersion = async () => {
    return await fetchWrapper({url:"api/release-version"});
  }

  return {
    getVersion
  }
}

export default versionService;